// extracted by mini-css-extract-plugin
export default {"article":"ArticleForm_article__Ppn9o","control_box":"ArticleForm_control_box__zeAB4","btn_icon":"ArticleForm_btn_icon__T4xp2"};